import React from 'react';
import Card from '../../ui/Card';
import { AlertTriangleIcon, TrendingDownIcon, AlertCircleIcon, InfoIcon } from 'lucide-react';
const ExecutiveAlertsPanel: React.FC = () => {
  const alerts = [{
    type: 'critical',
    icon: <AlertTriangleIcon size={18} data-id="element-2818" />,
    title: 'Margin Compression Alert',
    description: 'EBITDA margin declined 0.3% MoM in South region due to increased material costs',
    action: 'Review pricing strategy',
    color: 'text-red-600 bg-red-50 border-red-200'
  }, {
    type: 'warning',
    icon: <TrendingDownIcon size={18} data-id="element-2819" />,
    title: 'Sales Slowdown',
    description: 'East region sales down 8.5% vs target; dealer inventory building up',
    action: 'Activate dealer incentives',
    color: 'text-orange-600 bg-orange-50 border-orange-200'
  }, {
    type: 'warning',
    icon: <AlertCircleIcon size={18} data-id="element-2820" />,
    title: 'Warranty Cost Spike',
    description: 'LED headlamp warranty claims up 15% - potential quality issue detected',
    action: 'Initiate root cause analysis',
    color: 'text-yellow-600 bg-yellow-50 border-yellow-200'
  }, {
    type: 'info',
    icon: <InfoIcon size={18} data-id="element-2821" />,
    title: 'Low Inventory Risk',
    description: 'Safety products inventory at 22 days - below target of 30 days',
    action: 'Expedite production',
    color: 'text-blue-600 bg-blue-50 border-blue-200'
  }];
  return <Card className="p-6 mb-6 bg-gradient-to-br from-red-50 to-white border-2 border-red-100" data-id="element-2822">
      <div className="flex items-center justify-between mb-4" data-id="element-2823">
        <div data-id="element-2824">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-2825">Executive Alerts</h3>
          <p className="text-sm text-gray-600" data-id="element-2826">
            Critical items requiring immediate attention
          </p>
        </div>
        <div className="text-2xl font-bold text-red-600" data-id="element-2827">{alerts.length}</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2828">
        {alerts.map((alert, index) => <div key={index} className={`${alert.color} border-2 rounded-lg p-4`} data-id="element-2829">
            <div className="flex items-start mb-2" data-id="element-2830">
              <div className={`${alert.color.split(' ')[0]} mr-2 mt-0.5`} data-id="element-2831">
                {alert.icon}
              </div>
              <div className="flex-1" data-id="element-2832">
                <div className="font-bold text-sm mb-1" data-id="element-2833">{alert.title}</div>
                <div className="text-xs text-gray-700 mb-2" data-id="element-2834">
                  {alert.description}
                </div>
                <button className="text-xs font-semibold underline hover:no-underline" data-id="element-2835">
                  {alert.action} →
                </button>
              </div>
            </div>
          </div>)}
      </div>
    </Card>;
};
export default ExecutiveAlertsPanel;